module.exports = __webpack_public_path__ + "static/media/hearty.8daee553.jpg";